import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useAgentRef(
  exceptAgentId?: number,
  exceptAgentDossierId?: number
) {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    ["agents", exceptAgentId, exceptAgentDossierId],
    async () => {
      return await api.agents(exceptAgentDossierId, exceptAgentId);
    },
    {}
  );

  return {
    agents: data ?? [],
    agentsLoading: isFetching,
    refetchAgentsRef: refetch,
  };
}
